
import { Component, Vue, Prop, PropSync, Watch } from "vue-property-decorator";
import { formatUpyunUrl } from "@/utils";
import { addOpenLeads } from "@/apis/home";
import ApplySuccessDialog from "@/components/ApplySuccessDialog.vue";
@Component({
  components: {
    ApplySuccessDialog
  }
})
export default class ApplyFormDialog extends Vue {
  @PropSync("show") dialogVisible!: boolean;
  @Prop({ required: true }) private title!: any;
  @Prop({ required: false }) private course: any;

  formatUpyunUrl = formatUpyunUrl;
  successShow = false;
  status = 0; //0未申请,1已申请

  form = {
    name: "",
    job: "",
    open_name: "",
    revenue: "",
    tel: "",
    cust_remark: ""
  };
  options1 = [
    {
      value: "董事长",
      label: "董事长"
    },
    {
      value: "总裁/CEO",
      label: "总裁/CEO"
    },
    {
      value: "副总裁/分公司总经理/事业部总经理",
      label: "副总裁/分公司总经理/事业部总经理"
    },
    {
      value: "培训负责人/人力资源负责人",
      label: "培训负责人/人力资源负责人"
    },
    {
      value: "其他高管",
      label: "其他高管"
    }
  ];
  options2 = [
    {
      value: "1000万-5000万",
      label: "1000万-5000万"
    },
    {
      value: "5000万-1亿",
      label: "5000万-1亿"
    },
    {
      value: "1亿-3亿",
      label: "1亿-3亿"
    },
    {
      value: "3亿-5亿",
      label: "3亿-5亿"
    },
    {
      value: "5亿以上",
      label: "5亿以上"
    }
  ];

  handleClose() {
    this.dialogVisible = false;
  }

  submit() {
    if (this.status == 1) {
      this.successShow = true;
      return false;
    }
    this.clickSure();
  }

  async clickSure() {
    if (!this.form.name) {
      this.$message.warning("请填写姓名");
      return false;
    }
    if (!this.form.tel) {
      this.$message.warning("请填写联系电话");
      return false;
    }

    if (this.form.tel.length != 11) {
      this.$message.warning("请填写正确手机号");
      return false;
    }

    if (!this.form.job) {
      this.$message.warning("请填写职务");
      return false;
    }
    if (!this.form.open_name) {
      this.$message.warning("请填写公司名称");
      return false;
    }
    if (!this.form.revenue) {
      this.$message.warning("请填写营收规模");
      return false;
    }

    let params = {} as any;
    params.name = this.form.name;
    params.job = this.form.job;
    params.open_name = this.form.open_name;
    params.tel = this.form.tel;
    params.revenue = this.form.revenue;
    params.cust_remark = this.form.cust_remark;
    params.source = "NWEB";
    if (this.course) {
      params.sub_source = "申请报名《" + this.course.title + "》";
    } else {
      params.sub_source = this.title;
    }

    await addOpenLeads(params);
    this.dialogVisible = false;
    this.form = {
      name: "",
      job: "",
      open_name: "",
      revenue: "",
      tel: "",
      cust_remark: ""
    };

    this.status = 0;
    this.successShow = true;
    // this.$message.success("已经提交成功，我们会尽快和您联系");
  }

  dialogClose() {
    this.status = 1;
  }

  handleInput(value: any) {
    console.log(123);
    this.form.tel = value.replace(/[^\d]/g, ""); // 只保留数字
  }
}
